import { Reducer } from 'redux';
import { getType } from '@anm/helpers/saga/typesafe-actions';

import { subscriptionActions } from '..';
import { CancelSubscriptionState, SubscriptionActions } from '../types';

const initialCancelSubscriptionState: CancelSubscriptionState = {
  data: null,
  error: null,
  isError: false,
  isPending: false
};

const cancelSubscriptionReducer: Reducer<
  typeof initialCancelSubscriptionState,
  SubscriptionActions
> = (state = initialCancelSubscriptionState, action) => {
  switch (action.type) {
    case getType(subscriptionActions.cancelSubscriptionAsync.request): {
      return {
        ...state,
        isError: false,
        isPending: true
      };
    }

    case getType(subscriptionActions.cancelSubscriptionAsync.success): {
      return {
        ...state,
        data: action.payload,
        isError: false,
        isPending: false
      };
    }

    case getType(subscriptionActions.cancelSubscriptionAsync.failure): {
      return {
        ...state,
        error: action.payload,
        isError: true,
        isPending: false
      };
    }
    default:
      return state;
  }
};

export default cancelSubscriptionReducer;
